import { toast } from 'sonner';

import { useApiMutation, useApiQuery } from '@/modules/common';
import { PrinterType } from '@/modules/common/types';
import { useModelAttributes } from '@/modules/models';

import { GcrFileItem, GcrUploadUrlData, UpdateGcrBody } from '../types';

export function useGcrsDetails(maskId: string) {
  const { data: optionsData } = useModelAttributes();

  const { data: printers } = useApiQuery<PrinterType[]>('/printers', {
    queryKey: ['printers'],
    initialData: [],
  });

  const { data: uploadUrlData, refetch: refetchUploadUrl } =
    useApiQuery<GcrUploadUrlData>(`/gcrs/reupload-url/${maskId}`, {
      queryKey: ['gcrsDetailsUploadUrl'],
      initialData: null,
    });

  const { isFetching, data } = useApiQuery<GcrFileItem>(`/gcrs/${maskId}`, {
    queryKey: ['gcrsDetails'],
    initialData: null,
  });

  const updateGcrMutation = useApiMutation<UpdateGcrBody>(
    '/gcrs',
    {
      method: 'PATCH',
    },
    {
      onError: () => {
        toast.error('Uh oh! Something went wrong.');
      },
    }
  );

  return {
    optionsData: {
      printers,
      ...optionsData,
    },
    isFetching,
    uploadUrlData,
    details: data,
    refetchUploadUrl,
    updateGcrMutation,
  } as const;
}
